<template>
    <div class="col-md-12 table-responsive">
        <table class="datatable table table-striped">
            <thead>
                <tr>
                    <th scope="col">Dispositivo</th>
                    <th scope="col">Valore</th>
                    <th scope="col">Data acquisizione</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                    <td v-html="row['deviceId']"></td>
                    <td v-html="row['stringValue'] + (row['stringUnit'] != undefined ? ' ' + row['stringUnit']: '')"></td>                    
                    <td v-html="row['stringTimestamp']"></td>
                </tr>                
            </tbody>
        </table>

        <overlay :enabled="loading"></overlay>
    </div>    
</template>

<script>
    import moment from 'moment'
    import notificator from '../mixins/notificator';
    import { mapGetters } from 'vuex'
    
    import Overlay from '@/components/Overlay.vue';

    export default {
        props: ['page', 'settings', 'getData'],

        components: {Overlay},   

        mixins: [notificator],

        data() {
            return {
                rows: [],
                loading: false,
                fields: {
                    parametersAttributes: {},
                    aggregationFrequencyAttributes: {},
                    aggregationModeAttributes: {},
                    lowerboundAttributes: {},
                    upperboundAttributes: {}
                },  
            }
        },

        created() {
            //Parameters
            this.fields.parametersAttributes = this.settings.parametersAttributes;
            this.fields.parametersAttributes['value']['value'] = this['selected' + this.keyword + 'Parameters'];
            
            //Aggregation frequency
            this.fields.aggregationFrequencyAttributes = this.settings.aggregationFrequencyAttributes;
            this.fields.aggregationFrequencyAttributes['value']['value'] = this['selected' + this.keyword + 'AggregationFrequency'];
            
            //Aggregation mode
            this.fields.aggregationModeAttributes = this.settings.aggregationModeAttributes;
            this.fields.aggregationModeAttributes['value']['value'] = this['selected' + this.keyword + 'AggregationMode'];
            
            //Lowerbound
            this.fields.lowerboundAttributes = this.settings.lowerboundAttributes;
            this.fields.lowerboundAttributes['value']['value'] = this['selected' + this.keyword + 'Lowerbound'];
            
            //Upperbound
            this.fields.upperboundAttributes = this.settings.upperboundAttributes;
            this.fields.upperboundAttributes['value']['value'] = this['selected' + this.keyword + 'Upperbound'];

            if(this.getData != null) {
                this.getTSData();
            }
        },

        computed: {    
            ...mapGetters([
                'selectedAcquisitionsDevices',
                'selectedAcquisitionsParameters',
                'selectedAcquisitionsAggregationFrequency',
                'selectedAcquisitionsAggregationMode',
                'selectedAcquisitionsLowerbound',
                'selectedAcquisitionsUpperbound',
                
                'selectedConsumptionsDevices',
                'selectedConsumptionsParameters',
                'selectedConsumptionsAggregationFrequency',
                'selectedConsumptionsAggregationMode',
                'selectedConsumptionsLowerbound',
                'selectedConsumptionsUpperbound',
            ]),
            
            keyword() {
                return this.getFirstLetterUppercase(this.page);
            }
        },

        watch: {
            getData() {
                if(this.getData != null) {
                    this.getTSData();
                }
            },
        },

        methods: {
            getFirstLetterUppercase(string) {
                return string.charAt(0).toUpperCase() + string.slice(1)
            },
            generateDevicesQueries() {
                var offset = new Date().getTimezoneOffset();
                
                var deviceIds;

                if(this.page == 'acquisitions' && this['selected' + this.keyword + 'Devices']['multidevice'] != undefined) {
                    deviceIds = [];

                    for(var i = 0; i < this['selected' + this.keyword + 'Devices']['devices'].length; i++) {
                        deviceIds.push(this['selected' + this.keyword + 'Devices']['devices'][i]['device']['id']);
                    }
                } else
                    deviceIds = [this['selected' + this.keyword + 'Devices']['device']['id']];

                var request = [{
                    deviceIds: deviceIds,
                    paramIds: [this['selected' + this.keyword + 'Parameters']],
                    queryId: 'TABLE',
                    // 'readingType': this.widget.attributes.readingType.attributeValue
                }];

                if(this.fields.lowerboundAttributes != undefined && this['selected' + this.keyword + 'Lowerbound'] != undefined) {
                    if(this.fields.lowerboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
                        var lower = this['selected' + this.keyword + 'Lowerbound'].split(" ");                        
                        request[0]['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    } else {
                        request[0]['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    }
                }
                
                if(this.fields.upperboundAttributes != undefined && this['selected' + this.keyword + 'Upperbound'] != undefined) {
                    if(this.fields.upperboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
                        var upper = this['selected' + this.keyword + 'Upperbound'].split(" ");
                        request[0]['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    } else {
                        request[0]['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Upperbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    }
                }

                if(this['selected' + this.keyword + 'AggregationFrequency'] != undefined && this['selected' + this.keyword + 'AggregationFrequency'] != null) {
                    if(request[0]['aggregation'] == undefined)
                        request[0]['aggregation'] = {};
                    
                    request[0]['aggregation']['frequency'] = this['selected' + this.keyword + 'AggregationFrequency'];
                }

                if(this['selected' + this.keyword + 'AggregationMode'] != undefined && this['selected' + this.keyword + 'AggregationMode'] != null) {
                    if(request[0]['aggregation'] == undefined)
                        request[0]['aggregation'] = {};

                    request[0]['aggregation']['mode'] = this['selected' + this.keyword + 'AggregationMode'];
                }
            
                return request;
            },

            getTSData() {
                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getTSData', {devicesQueries: this.generateDevicesQueries()})
                .catch(error => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: error}));            

                    this.rows = [];

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                    this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: 200}));

                    if(data != undefined && data.deviceQueriesResponse != undefined && data.deviceQueriesResponse.TABLE[0] != undefined) {
                        this.rows = data.deviceQueriesResponse.TABLE;
                    } else {
                        this.rows = [];
                    }

                    if(!this.ready)
                        this.ready = true;
                });          
            },

            overlay(action) {
                this.loading = action;
            }, 
        }
    }
</script>
